<template>
  <div>
    <div class="subtitle1 mb-3 mt-5">{{ $t("coroMailSettings.messageSettings") }}</div>
    <v-form>
      <v-checkbox
        data-testid="restrict-message-forwarding-checkbox"
        :ripple="false"
        v-model="localValue.restrictForwarding"
        :disabled="disabled"
        :label="$t('coroMailSettings.restrictMessageForwarding')"
      />
      <v-checkbox
        data-testid="message-expiration-checkbox"
        :ripple="false"
        v-model="localValue.expirationEnabled"
        :disabled="disabled"
        :label="$t('coroMailSettings.setMessageExpiration')"
      />
      <v-text-field
        v-model.number="localValue.expirationCountDays"
        :disabled="!localValue.expirationEnabled || disabled"
        data-testid="number-of-days-textfield"
        class="mt-2 ml-8 number-of-days-textfield"
        type="number"
        :label="$t('coroMailSettings.numberOfDays.label')"
        :aria-label="$t('coroMailSettings.numberOfDays.label')"
        :placeholder="$t('coroMailSettings.numberOfDays.placeholder')"
        :rules="[minNumber()]"
      >
      </v-text-field>
    </v-form>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType, toRefs } from "vue";
import { minNumber } from "@/_helpers/validators";
import { type EmailSecuritySettings } from "@/_store/email-security/email-settings.module";

import { useTwoWayBinding } from "@/composables/useTwoWayBinding.ts";

export default defineComponent({
  name: "SecureMessageSettings",
  props: {
    modelValue: {
      type: Object as PropType<EmailSecuritySettings>,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const localValue = useTwoWayBinding(modelValue, (value) => {
      emit("update:modelValue", value);
    });

    return {
      localValue,
      minNumber,
    };
  },
});
</script>

<style lang="scss" scoped>
.number-of-days-textfield {
  width: 200px;
}

:deep(*) {
  .v-input__append {
    margin: 0;
  }
}
</style>
